// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__S2Bc2","card":"NotFoundPage_card__v+IrC","code":"NotFoundPage_code__jVIGG","brand":"NotFoundPage_brand__CLyyA","link":"NotFoundPage_link__OsKFs"};